(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches;
  const syncMotion = () => {
    document.body.toggleAttribute('data-motion-paused', paused);
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? button.dataset.resume : button.dataset.pause;
    });
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-motion-toggle]');
    if (toggle) { paused = !paused; syncMotion(); }
    const thumb = event.target.closest('[data-studio-gallery] a');
    if (!thumb || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const hero = thumb.closest('.studio-visual').querySelector('[data-tech-media] img');
    if (!hero) return;
    event.preventDefault();
    hero.removeAttribute('srcset');
    hero.src = thumb.href;
    hero.alt = thumb.querySelector('img').alt;
    thumb.parentElement.querySelectorAll('a').forEach(link => link.removeAttribute('aria-current'));
    thumb.setAttribute('aria-current', 'true');
  });
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!paused) entry.target.classList.add('studio-reveal');
      revealObserver.unobserve(entry.target);
    });
  }, {threshold: .12}) : null;
  const initialize = (root = document) => {
    root.querySelectorAll('[data-tech-media]').forEach(media => {
      if (media.dataset.studioBound) return;
      media.dataset.studioBound = 'true';
      media.addEventListener('pointermove', event => {
        if (paused || reduced.matches || event.pointerType !== 'mouse') return;
        const bounds = media.getBoundingClientRect();
        media.style.setProperty('--tilt-x', ((.5 - (event.clientY - bounds.top) / bounds.height) * 8) + 'deg');
        media.style.setProperty('--tilt-y', (((event.clientX - bounds.left) / bounds.width - .5) * 8) + 'deg');
      });
      media.addEventListener('pointerleave', () => {
        media.style.setProperty('--tilt-x', '0deg');
        media.style.setProperty('--tilt-y', '0deg');
      });
    });
    root.querySelectorAll('.section .card,.section h2,.studio-stage h2').forEach(el => revealObserver?.observe(el));
    root.querySelectorAll('.studio-product').forEach(section => {
      if (section.dataset.stickyBound) return;
      const button = section.querySelector('form .buy');
      const sticky = section.querySelector('.sticky');
      if (!button || !sticky || !('IntersectionObserver' in window)) return;
      section.dataset.stickyBound = 'true';
      sticky.hidden = true;
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, {threshold: 0}).observe(button);
    });
    root.querySelectorAll('[data-m-slider]').forEach(slider => {
      if (slider.dataset.bound) return; slider.dataset.bound = 'true';
      const wrap = slider.parentElement, dots = wrap.querySelectorAll('.m-dots i'), idx = wrap.querySelector('[data-m-index]');
      let raf = 0;
      slider.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(slider.scrollLeft / slider.clientWidth);
          dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
          if (idx) idx.textContent = i + 1;
        });
      }, {passive: true});
    });
    syncMotion();
  };
  let scheduled = false;
  const updateProgress = () => {
    const range = document.documentElement.scrollHeight - innerHeight;
    document.documentElement.style.setProperty('--page-progress', range > 0 ? Math.max(0, Math.min(1, scrollY / range)) : 0);
    scheduled = false;
  };
  addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateProgress); } }, {passive: true});
  addEventListener('resize', updateProgress);
  reduced.addEventListener('change', () => { paused = reduced.matches; syncMotion(); });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.studio-reveal').forEach(el => revealObserver?.unobserve(el)));
  initialize();
  updateProgress();
})();
